import { Col, Row, Table } from "react-bootstrap";
import { isSuperAdmin } from "../../../Services/common";
import { getColorFromStatus } from "../../../Utils/appUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import ImageResource from "../../../Wrapper/ImageResource/ImageResource";
import Button from "../../_widgets/Button/Button";
import DateRangePicker from "../../_widgets/DateRangePicker/DateRangePicker";
import Input from "../../_widgets/Input/Input";
import MainLoader from "../../_widgets/Loader/MainLoader";
import ModalImport from "../../_widgets/Modal/ModalImport";
import NavBar from "../../_widgets/NavBar/NavBar";
import CustomPagination from "../../_widgets/Pagination/Pagination";
import Text from "../../_widgets/Text/Text";
import CustomTooltip from "../../_widgets/Tooltip/CustomTooltip";
import AnimatedPage from "../../AnimatedPage/AnimatedPage";
import EditApplicationsModal from "./EditApplicationsModal";

const ApplicationsUI = ({
  modalShow,
  importListing,
  exportList,
  importModal,
  importList,
  setSelectedRows,
  setImportModal,
  openImportModal,
  setModalShow,
  statusHandler,
  handleClose,
  applicationList,
  addApplicationData,
  setAddApplicationData,
  addApplication,
  editApplication,
  onPageChange,
  dates,
  setDates,
  datePickerStartRef,
  datePickerEndRef,
  searchQuery,
  setSearchQuery,
  loading,
  buttonLoading,
  Action,
  selectedRows,
  getApplicationsList,
}) => {
  return (
    <AnimatedPage>
      <NavBar
        button="Add Application"
        buttonIcon="application"
        button2={!isSuperAdmin() && "Import Applications"}
        buttonIcon2="download"
        button2onclick={openImportModal}
        heading="Applications List"
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        setModalShow={setModalShow}
        Icon="menu"
      />

      <ModalImport
        show={importModal}
        handleClose={() => setImportModal(false)}
        buttonLoading={buttonLoading}
        handleSaveClick={exportList}
        loading={loading}
        name="Application(s)"
        data={importList}
        importListing={importListing}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />

      <EditApplicationsModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        handleClose={handleClose}
        addApplicationData={addApplicationData}
        addApplication={addApplication}
        editApplication={editApplication}
        buttonLoading={buttonLoading}
        setAddApplicationData={setAddApplicationData}
      />

      <div className="patient_list white_card">
        <div className="top_bar">
          <Text type="h2" text="" />
          <Row className="search_filter">
            <Col lg={4}>
              <div>
                <Input
                  placeholder="Search"
                  id="searchInput"
                  suffixIcon="search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onClickIconSuff={() => getApplicationsList()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      getApplicationsList();
                    }
                  }}
                  iconTooltip="Search"
                />
              </div>
            </Col>
            <Col lg={8}>
              <div className="date_range_picker">
                <DateRangePicker
                  startDate={dates?.startDate}
                  setStartDate={(startDate) => setDates({ ...dates, startDate })}
                  endDate={dates?.endDate}
                  setEndDate={(endDate) => setDates({ ...dates, endDate })}
                  onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                  datePickerStartRef={datePickerStartRef}
                  datePickerEndRef={datePickerEndRef}
                  showDateShortcuts={true}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : applicationList?.data?.length > 0 ? (
            <>
              <div>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {applicationList?.data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <CustomTooltip text={data.name} placement={"top"}>
                              {stringUtils.slice(data.name, 20)}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip text={data.description} placement="top">
                              {data.description ? stringUtils.slice(data.description, 30) : "-"}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip
                              type="popover"
                              button={
                                <div className="p-1">
                                  <Button
                                    isLoading={buttonLoading}
                                    onClick={() => statusHandler(data)}
                                    buttonType="primary"
                                    text={data.status === "ACTIVE" ? "Deactivate" : "Activate"}
                                  />
                                </div>
                              }
                              placement="top"
                            >
                              <div className={`status status__${getColorFromStatus(data.status)}`}>
                                <Text text={stringUtils.capitalizeFirstLetter(data.status)} />
                              </div>
                            </CustomTooltip>
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <CustomTooltip text="Edit" placement={"top"}>
                                <Button
                                  className="p-1 bg-transparent border-0"
                                  icon={<IconResource type="edit" color="var(--light-text)" />}
                                  onClick={() => Action(data, "edit")}
                                />
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <CustomPagination
                activePage={applicationList?.current_page}
                onPageChange={onPageChange}
                pageLength={applicationList?.per_page}
                totalData={applicationList?.total}
                lastPage={applicationList?.last_page}
              />
            </>
          ) : (
            <>
              <div className="no_data position-relative">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text="There is no data to display. Try re-setting filters!" />
                <Button
                  buttonType="primary"
                  text="Add Application"
                  suffixIcon={<IconResource type="application" />}
                  onClick={() => setModalShow(true)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default ApplicationsUI;
